import { render } from "./markters.vue?vue&type=template&id=2fac12e8&scoped=true"
import script from "./markters.vue?vue&type=script&lang=js"
export * from "./markters.vue?vue&type=script&lang=js"

import "./markters.vue?vue&type=style&index=0&id=2fac12e8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fac12e8"]])

export default __exports__